import { Injectable } from '@angular/core';
import { HttpClient,  HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, retry } from 'rxjs/operators';
import { User } from '../dto/user/user';
import { Reply } from '../dto/reply';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {

  constructor(private http: HttpClient) {
  }

  get(): Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/user').pipe(map(data => data));
  }

  delete(id: string): Observable<Reply> {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.http.delete('/api/User/' + id).pipe(map(
      (jsonItem => Reply.fromJson(jsonItem))
    ));
  }


  getAdmin(page: number, size: number, dataFilter: User, sortCol: string, sortDir: string): Observable<any> {
    let params = new HttpParams().append('page', page.toString()).append('size', size.toString())
    .append('sortCol', sortCol.toString()).append('sortDir', sortDir.toString());
    if(dataFilter) {
      Object.keys(dataFilter).forEach(item => {
        params = params.append(item.toString(), dataFilter[item]?.toString() || '')
      })
    }

    return this.http.get(environment.apiUrl + '/dashboard/admin/user', { params: params}).pipe(map(data => data));
  }

  getById(id: string): Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/admin/user/' + id).pipe(map(data => data));
  }

  modify(user: User): Observable<any> {
    return this.http.post(environment.apiUrl + '/dashboard/admin/user', user, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }).pipe(val => val);
  }

  deleteById(id: string): Observable<any> {
    return this.http.delete(environment.apiUrl + '/dashboard/admin/user/' + id).pipe(map(data => data));
  }
}
